import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AuthContext from '../../context/autenticacion/authContext.js';
import AuthShell, { Aviso, OK_RE } from './AuthShell';
import { useT } from 'i18n';

const ResetPassword = () => {
  const { t, ts } = useT();
  const { mensaje, olvidoPassword, Limpiar } = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [enviando, setEnviando] = useState(false);

  useEffect(() => { Limpiar(); return () => Limpiar(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { if (mensaje) setEnviando(false); }, [mensaje]);

  const enviar = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setEnviando(true);
    olvidoPassword({ email: email.trim() });
  };

  const listo = mensaje && /correo|verifique|enviado/i.test(mensaje) && OK_RE.test(mensaje);

  if (listo) {
    return (
      <AuthShell>
        <div className="p7a-estado">
          <div className="p7a-icono ok" aria-hidden="true">✓</div>
          <h2>{t('olvido.revisa')}</h2>
          <p>{t('olvido.revisaTxt1')}<strong>{email}</strong>{t('olvido.revisaTxt2')}</p>
          <Link to="/login" className="p7a-btn" style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }}>{t('olvido.volver')}</Link>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell titulo={t('olvido.titulo')} subtitulo={t('olvido.subtitulo')}>
      {mensaje && <Aviso texto={ts(mensaje)} />}
      <form onSubmit={enviar}>
        <div className="p7a-campo">
          <label htmlFor="email">{t('olvido.correo')}</label>
          <input id="email" name="email" type="email" placeholder={t('olvido.correoEjemplo')} value={email} onChange={(e) => { setEmail(e.target.value); if (mensaje) Limpiar(); }} required autoComplete="email" autoFocus />
        </div>
        <button type="submit" className="p7a-btn" disabled={enviando}>{enviando ? t('olvido.enviando') : t('olvido.enviar')}</button>
      </form>
      <div className="p7a-links">
        <Link to="/login">{t('olvido.volver')}</Link>
        <span>{t('olvido.sinCuenta')} <Link to="/nueva-cuenta">{t('olvido.registrate')}</Link></span>
      </div>
    </AuthShell>
  );
};

export default ResetPassword;
